
import { HasLikeItems } from '@/helpers/OrderlineHelper';
import { QuoteService } from '@/services/quote-service';
import { Item } from '@/store/models/ItemModel';
import { OrderlineDetails } from '@/store/models/OrderlineModel';
import { PricingMatrixModel } from '@/store/models/QuotesModel';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
@Component
export default class MinimumPriceBreak extends Vue {
  /* Properties */
  /* Store Actions */
  /* Watchers */
  /* Data */
  isLoading: boolean = false;
  dialog: boolean = false;
  difference: number = 0;
  orderline: OrderlineDetails = new OrderlineDetails();
  /* Computed */
  /* Async Functions */
  async GetMaximumQuantity() {
    const model = new PricingMatrixModel({
      DieId: this.orderline.Item.Die.Id,
      MaterialId: this.orderline.Item.Material.Id,
      FinishId: this.orderline.Item.Finish.Id,
      ColorId: this.orderline.Item.Color.Id,
      Quantity: this.orderline.Quantity,
      StartQuantity: this.orderline.Quantity,
      EndQuantity: this.orderline.Quantity,
      IncrementBy: 1000,
      ShouldUseVarData: this.orderline.Item.HasBarcode,
      ShouldUseVarnish: this.orderline.Item.HasVarnish
    });
    const response = await QuoteService.GetMaximumQuantityForBasePrice(model);
    if (response.data > this.orderline.Quantity) {
      this.difference = response.data - this.orderline.Quantity;
      this.orderline.Quantity = response.data;
      this.openDialog();
    }
  }
  /* Utility Functions */
  openDialog() {
    this.dialog = true;
  }
  closeDialog() {
    this.dialog = false;
  }
  updateOrderline() {
    this.$emit('priceBreakUpdate', this.orderline);
    this.closeDialog();
  }
  clearData() {
    this.orderline = new OrderlineDetails();
    this.difference = 0;
    this.closeDialog();
  }
  runQuote(ol: OrderlineDetails, allOrderlines: OrderlineDetails[] = []) {
    const orderlines = allOrderlines.filter(o => o.Id !== ol.Id);
    if (ol.ExtendedPrice < 99 && !HasLikeItems(orderlines, ol)) {
      this.orderline.SetData(ol);
      this.GetMaximumQuantity();
    }
  }
  /* Loaders */
  /* Mounted */
  /* Created */
  /* Emmited Functions */
}
